module.exports = __webpack_public_path__ + "img/60.a94452a0.jpg";